const baseStyle = {
  paddingX: 32,
  paddingTop: 32,
  paddingBottom: 24
}

export default {
  baseStyle
}
